import { render, staticRenderFns } from "./CreatetNewShopDialog.vue?vue&type=template&id=3c00d51e&scoped=true&lang=pug&"
import script from "./CreatetNewShopDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatetNewShopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreatetNewShopDialog.vue?vue&type=style&index=0&id=3c00d51e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00d51e",
  null
  
)

export default component.exports